import { Action } from "../actions/types"
import { VehicleRouteMappingMasterType, VehicleRouteMappingMasterActionList } from "../actions/vehicleRouteMappingMasterActions"

const initialValue: Array<VehicleRouteMappingMasterType> = []

const vehicleRouteMappingMasterReducer = (state: Array<VehicleRouteMappingMasterType> = initialValue, action: Action) => {
    switch (action.type) {

        case VehicleRouteMappingMasterActionList.ADD_VEHICLE_ROUTEMAPPING_MASTER:
            return [
                ...state,
                action.data,
            ]

        case VehicleRouteMappingMasterActionList.UPDATE_VEHICLE_ROUTEMAPPING_MASTER:
            const updated = [...state].slice()
            const index = updated.findIndex(u => u.id === action.data.id)

            if (index > -1) {
                updated[index] = {
                    ...action.data
                }
            }

            return updated

        case VehicleRouteMappingMasterActionList.FETCH_VEHICLE_ROUTEMAPPING_MASTER:
            return action.data

        case VehicleRouteMappingMasterActionList.DELETE_VEHICLE_ROUTEMAPPING_MASTER:
            return state.filter(s => s.id !== action.data)

        default:
            return state
    }
}

export default vehicleRouteMappingMasterReducer